import { EReducerActions, Actions, IHttpClientReducerState, HttpClientReducer } from './model';

export const initialState = {
  loading: true,
  error: [],
  data: null,
};

export const reducer: HttpClientReducer = <T>(prevState: IHttpClientReducerState<T>, action: Actions<T>) => {
  switch (action.actionType) {
    case EReducerActions.RESET:
      return initialState;
    case EReducerActions.SUCCESS:
      return {
        ...prevState,
        loading: false,
        ...action.payload,
      };
    case EReducerActions.WITH_WARNING:
      return {
        loading: false,
        ...action.payload,
      };
    case EReducerActions.REQUEST_FAILED:
      return {
        ...prevState,
        loading: false,
      };
    default:
      return prevState;
  }
};
